"use client";
import { PlayIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import { motion } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/solid";

export default function VideoCardComp({
  videos,
  limit = 12,
}: {
  videos: any[];
  limit: number;
}) {
  const [selectedVideo, setSelectedVideo] = useState<any | null>(null);

  return (
    <div>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {videos.slice(0, limit).map((item: any) => (
          <div
            key={item.id}
            className="group relative bg-black rounded-xl lg:rounded-2xl"
          >
            <div
              className="text-sm cursor-pointer"
              onClick={() => setSelectedVideo(item)}
            >
              <div className="relative">
                <div className="w-full aspect-[9/16] bg-gray-200 rounded-xl overflow-hidden lg:rounded-2xl shadow-sm hover:shadow-md">
                  <img
                    alt={item.name}
                    src={item.imageSrc}
                    className="w-full h-full object-cover"
                  />
                  <PlayIcon className="size-12 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white hover:text-opacity-70" />
                </div>
                <div className="p-2 absolute bottom-0 bg-black bg-opacity-20 rounded-b-xl lg:rounded-b-2xl">
                  <h3 className="text-white h-20 overflow-hidden">
                    {item.name}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {selectedVideo && (
        <div className="fixed inset-0 flex items-center justify-center bg-dark bg-opacity-80 p-4 z-50">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="relative max-w-3xl w-full bg-white rounded-xl lg:rounded-2xl"
          >
            <button
              className="absolute -top-3 -right-3 text-white bg-gray-800 p-2 rounded-full"
              onClick={() => setSelectedVideo(null)}
            >
              <XMarkIcon className="size-6" />
            </button>
            <iframe
              className="w-full max-w-[450px] mx-auto"
              width="450"
              height="550"
              src={`https://www.youtube.com/embed/${selectedVideo.id}`}
              title={selectedVideo.name}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>
          </motion.div>
        </div>
      )}
    </div>
  );
}
